import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PFieldSingleSelectService {
    private selectedValueChangeSubject = new BehaviorSubject<SelectedValueChangeInfo | null>(null);
    selectedValueChange$ = this.selectedValueChangeSubject.asObservable();

    onSelectedValueChange(selectedChangeInfo: SelectedValueChangeInfo | null) {
        this.selectedValueChangeSubject.next(selectedChangeInfo);
    }
}

export interface SelectedValueChangeInfo {
    fieldId: number;
    value: any;
}
